export default function Tos() {
  return (
    <>
      <div className="relative overflow-hidden">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto max-w-[37.5rem] pt-20 text-center pb-24">
            <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
              Terms of Service
            </h1>
          </div>
        </div>
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-[40rem] prose-sm prose prose-slate prose-a:font-semibold prose-a:text-sky-500 hover:prose-a:text-sky-600">
            <h2>Introduction</h2>
            <p>
              Welcome to Elmbase, Inc. (“Elmbase,\” “we,” “us,” or “our”), a
              professional network for real estate investors and sponsors. By
              accessing or using the Elmbase website (the “Site”) or any
              services offered by Elmbase (together with the Site, the
              “Services”), you agree to be bound by these Terms of Service and
              our Privacy Policy, whether or not you are a registered member of
              Elmbase. If you do not agree to these terms, you should not access
              or use the Services.
            </p>
            <h2>Services</h2>
            <p>
              Our Services allow users to connect with other real estate
              investors, real estate project sponsors, share information, and
              access investment opportunities. We provide access to a variety of
              features and tools, including but not limited to, search
              functionality, messaging, and project listings. We may update or
              modify our Services from time to time, and we reserve the right to
              do so without notice to you.
            </p>
            <h2>Eligibility</h2>
            <p>
              The Services are intended solely for users who are 18 or older. By
              using the Services, you represent and warrant that you are 18 or
              older.
            </p>
            <h2>User Accounts</h2>
            <p>
              In order to access certain features of our Services, you may need
              to create a user account. You are responsible for maintaining the
              confidentiality of your account and password, and you agree to
              accept responsibility for all activities that occur under your
              account. We reserve the right to terminate your account or access
              to our Services if we suspect any unauthorized use of your
              account.
            </p>
            <h2>User Content</h2>
            <p>
              Our Services allow users to post, upload, or otherwise make
              available content, including but not limited to, text, images, and
              videos (collectively, "User Content"). You are solely responsible
              for your User Content, and you agree not to upload, post, or
              otherwise make available any content that:
            </p>
            <ol>
              <li>
                Infringes any patent, trademark, trade secret, copyright, or
                other proprietary rights of any party;
              </li>
              <li>Is defamatory, libelous, or otherwise offensive;</li>
              <li>Is illegal or promotes illegal activities;</li>
              <li>
                Contains personal information about any individual, including
                but not limited to, addresses, phone numbers, or email
                addresses;
              </li>
              <li>Contains viruses, malware, or other harmful code; or</li>
              <li>Is otherwise in violation of these Terms.</li>
            </ol>
            <p>
              By uploading, posting, or otherwise making available User Content,
              you grant us a non-exclusive, worldwide, royalty-free,
              sublicensable, and transferable license to use, reproduce,
              distribute, prepare derivative works of, and display your User
              Content in connection with our Services and our business.
            </p>
            <h2>Use of the Services</h2>
            <p>
              You may use the Services only for lawful purposes and in
              accordance with these Terms of Service. You agree not to use the
              Services:
            </p>
            <ul>
              <li>
                in any way that violates any applicable federal, state, local,
                or international law or regulation;
              </li>
              <li>
                for the purpose of exploiting, harming, or attempting to exploit
                or harm minors in any way by exposing them to inappropriate
                content, asking for personally identifiable information, or
                otherwise;
              </li>
              <li>
                to transmit, or procure the sending of, any advertising or
                promotional material, including any “junk mail,” “chain letter,”
                “spam,” or any other similar solicitation;
              </li>
              <li>
                to impersonate or attempt to impersonate Elmbase, a Elmbase
                employee, another user, or any other person or entity;
              </li>
              <li>
                to engage in any other conduct that restricts or inhibits
                anyone’s use or enjoyment of the Services, or which, as
                determined by Elmbase, may harm Elmbase or users of the Services
                or expose them to liability;
              </li>
            </ul>
            <h2>Proprietary Rights</h2>
            <p>
              The Services and all materials contained on the Site, including
              without limitation text, photographs, videos, audio clips, written
              posts, articles, comments, software, scripts, graphics, and
              interactive features (collectively, “Content”), and all
              intellectual property rights related to the Content, are the
              exclusive property of Elmbase and/or our licensors or assigns. The
              Content is protected by copyright, trademark, and other laws of
              the United States and foreign countries. Elmbase reserves all
              rights in the Content not expressly granted to you in these Terms
              of Service.
            </p>
            <h2>Disclaimer of Warranty </h2>
            <p>
              YOU ACKNOWLEDGE AND AGREE THAT THE ELMBASE PLATFORM AND/OR THE
              SERVICES ARE BEING PROVIDED ON AN "AS IS'' BASIS WITHOUT WARRANTY
              OF ANY KIND, EXPRESS OR IMPLIED, AND MAY INCLUDE CERTAIN ERRORS,
              OMISSIONS, OUTDATED INFORMATION WHICH MAY AFFECT THE QUALITY OF
              THE CONTENT. YOU ACKNOWLEDGE THAT THE CONTENT HAVE NOT BEEN
              INDEPENDENTLY VERIFIED OR AUTHENTICATED IN WHOLE OR IN PART BY
              ELMBASE, AND AGREE THAT ELMBASE DOES NOT WARRANT THE ACCURACY OR
              TIMELINESS OF THE CONTENT AND FURTHER AGREE THAT ELMBASE HAS NO
              LIABILITY FOR ANY ERRORS OR OMISSIONS IN THE CONTENT, WHETHER
              PROVIDED BY ELMBASE OR ITS LICENSORS. ELMBASE MAKES NO
              REPRESENTATIONS OR WARRANTIES WITH RESPECT TO THE ELMBASE
              PLATFORM’S UP TIME NOR THE USABILITY OR ACCESSIBILITY OF THE
              ELMBASE PLATFORM BY USERS, INVESTORS, ISSUERS, SPONSORS, OR
              VISITORS OF THE ELMBASE PLATFORM. ELMBASE, FOR ITSELF AND EACH OF
              ITS LICENSORS, MAKES NO REPRESENTATIONS, WARRANTIES, OR GUARANTEES
              AS TO THE QUALITY, SUITABILITY, TRUTH, ACCURACY OR COMPLETENESS OF
              ANY INFORMATION OR MATERIAL CONTAINED ON THE ELMBASE PLATFORM
              AND/OR THE SERVICES, INCLUDING WITHOUT LIMITATION THE CONTENT AND
              ANY THIRD-PARTY CONTENT. UNLESS OTHERWISE EXPLICITLY STATED, TO
              THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE ELMBASE
              PLATFORM AND/OR THE SERVICES AND ANY INFORMATION OR MATERIAL
              CONTAINED ON THE ELMBASE PLATFORM IS PROVIDED TO YOU ON AN "AS
              IS'' BASIS AND IS FOR PERSONAL USE OR INTERNAL BUSINESS USE ONLY.
              ALL CONDITIONS, REPRESENTATIONS AND WARRANTIES, WHETHER EXPRESS,
              IMPLIED, STATUTORY OR OTHERWISE, INCLUDING ANY IMPLIED WARRANTY OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
              NON-INFRINGEMENT OF THIRD-PARTY RIGHTS, ARE HEREBY DISCLAIMED.
              ELMBASE PROVIDES THE SERVICES "AS-IS'' WITHOUT ANY WARRANTY OF ANY
              KIND. WE MAKE NO REPRESENTATION THAT THE CONTENT ON THE ELMBASE
              PLATFORM CONFORM TO YOUR LOCAL LAWS, AND IF YOU ARE ACCESSING THE
              ELMBASE PLATFORM FROM A LOCATION OUTSIDE THE UNITED STATES, YOU
              ALONE ARE RESPONSIBLE FOR COMPLIANCE WITH YOUR LOCAL LAWS. WE
              HEREBY DISCLAIM ANY AND ALL WARRANTIES, WHETHER EXPRESS, IMPLIED
              OR STATUTORY, INCLUDING, WITHOUT LIMITATION, ANY WARRANTIES OF
              TITLE, NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A
              PARTICULAR PURPOSE. THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU, TO
              THE EXTENT THAT APPLICABLE LAW MAY NOT ALLOW THE EXCLUSION OF
              IMPLIED WARRANTIES.
            </p>
            <h2>Limitation of Liability</h2>
            <p>
              IN THE CASE OF NEGLIGENCE, NEITHER ELMBASE, NOR ANY OF ITS
              AFFILIATES, NOR ANY PARTNERS, DIRECTORS, OFFICERS, EMPLOYEES OR
              AGENTS, THIRD-PARTY PROVIDERS, OR CONTENT PROVIDERS OF THE
              FOREGOING SHALL BE LIABLE TO YOU OR ANY THIRD-PARTY FOR ANY FORM
              OF DAMAGES (INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT,
              INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES) ARISING OUT OF OR
              RELATED TO THE USE OR ATTEMPTED USE OF THE ELMBASE PLATFORM OR THE
              SERVICES, INCLUDING BUT NOT LIMITED TO, TECHNICAL ERRORS,
              ACCIDENTAL ERRORS, YOUR INABILITY TO ACCESS THE ELMBASE PLATFORM,
              THE RESULTS OF YOUR USE OF THE ELMBASE PLATFORM AND/OR THE
              SERVICES, OR ANY EXTERNAL WEBSITES LINKED TO THE ELMBASE PLATFORM,
              OR THE CONTENT ON THE ELMBASE PLATFORM, HOWEVER ARISING, WHETHER
              FOR BREACH OR IN TORT, EVEN IF ELMBASE WAS INFORMED OF THE
              POSSIBILITY OF SUCH DAMAGES. IN THE EVENT ELMBASE OR ANY OF ITS
              PARTNERS, AGENTS, THIRD-PARTY PROVIDERS OR CONTENT PROVIDERS ARE
              FOUND TO BE GROSSLY NEGLIGENT OR WILLFUL IN THEIR MISCONDUCT, BY
              AN ARBITRATOR AUTHORIZED TO ACT BY THESE TERMS, DAMAGES WILL BE
              LIMITED TO (i) $0.01 FOR USERS, OR (ii) THE TOTAL AMOUNT OF
              REMUNERATION RECEIVED BY ELMBASE FOR EACH ISSUERS’ OR SPONSORS’
              ELEVANT OFFERING WITH RESPECT TO EACH ISSUER.
            </p>
            <h2>Indemnification</h2>
            <p className="pb-10">
              You agree to defend, indemnify and hold harmless Elmbase and its
              affiliates, representatives, partners, agents and employees from
              and against any and all liabilities, claims, costs and expenses,
              including attorneys` fees, that arise out of or in connection with
              your use of the Elmbase Platform and/or the Services or breach of
              these Terms.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
